import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../../config/routes";

const NAV_TABS = [
  { label: "Activity", to: ROUTES.ADMIN_ANALYTICS_PLUS() },
  { label: "Search", to: ROUTES.ADMIN_ACTIVITY_SEARCH() },
  { label: "Clicks", to: ROUTES.ADMIN_ACTIVITY_CLICKS() },
];

const ActivityNavTabs: React.FC = () => (
  <div className="flex flex-wrap gap-1 mb-8 border-b border-gray-200">
    {NAV_TABS.map((tab) => (
      <NavLink
        key={tab.to}
        to={tab.to}
        end
        className={({ isActive }) =>
          `px-4 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
            isActive
              ? "border-primary text-primary"
              : "border-transparent text-gray-500 hover:text-gray-700"
          }`
        }
      >
        {tab.label}
      </NavLink>
    ))}
  </div>
);

export default ActivityNavTabs;
